import request from "@/CommonDP/utils/request";
export default {
    //添加计划组
    addConstructionPlan(params) {
      return request.post(`/constructionPlan/addConstructionPlan`,params);
    },

    /**删除计划组 */
    delConstructionPlan(conPlanId) {
        return request.get(`/constructionPlan/delConstructionPlan?conPlanId=${conPlanId}`)
    },
    editConstructionPlan(conPlanName,conPlanId) {
      return request.get(`/constructionPlan/editConstructionPlan?conPlanName=${conPlanName}&conPlanId=${conPlanId}`);
    },
    getConstructionPlan(params) {
      return request.post(`/constructionPlan/getConstructionPlan`,params);
    },
    queryPlanList(data,conPlanId) {
      return request
        .post(`/constructionPlan/query-tree?conPlanId=${conPlanId}`, data)
        .then((res) => res);
    },
    addPlan(data) {
      return request.post(`/constructionPlan/add`, data).then((res) => res);
    },
    editPlan(data) {
      return request .post(`/constructionPlan/update`, data)
    },
    movePlan(taskId, moveType) {
      return request.post(`/lc/prj-plan-task/move?taskId=${taskId}&moveType=${moveType}`)
    },
    queryDetail(taskId) {
      return request.get(`/constructionPlan/detail?taskId=${taskId}`)
    },

    getSpecList() {
      return request.get(`/constructionPlan/getSpecList`)
    },
    enterpriseimport(params) {
      return request
        .post(`/constructionPlan/import`, params)
        .then((res) => res);
    },
    updatePlanIsHomePageShow(conPlanId,prjId) {
    return request.get(`/constructionPlan/updatePlanIsHomePageShow?conPlanId=${conPlanId}&prjId=${prjId}`)
  },
}